<template>
  <g transform="translate(-2,0) matrix(0.9 0 0 0.9 0 0)">
    <path
      d="M15.4219 9.53608V1.64795"
      stroke="inherit"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
    <path
      d="M15.4219 19.3668V15.4424"
      stroke="inherit"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.375 12.4824C18.375 14.1134 17.0528 15.4356 15.4219 15.4356C13.7909 15.4356 12.4688 14.1134 12.4688 12.4824C12.4688 10.8515 13.7909 9.5293 15.4219 9.5293V9.5293C17.0528 9.5293 18.375 10.8515 18.375 12.4824V12.4824Z"
      stroke="inherit"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
    <path
      d="M5.57812 7.56738V19.3668"
      stroke="inherit"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.53125 4.60742V4.60742C8.53125 2.97646 7.20909 1.6543 5.57813 1.6543C3.94716 1.6543 2.625 2.97646 2.625 4.60742C2.625 6.23839 3.94716 7.56055 5.57813 7.56055V7.56055C7.20909 7.56055 8.53125 6.23839 8.53125 4.60742V4.60742V4.60742Z"
      stroke="inherit"
      fill="none"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
</template>
